'use strict';

const AUTH_SIGN_UP = '/api/users.json';
const AUTH_SIGN_IN = '/api/users/sign_in.json';

class Auth {
    /*@ngInject*/
    constructor($http, $q, $localStorage, $mdDialog, $state) {
        "ngInject";
        _.extend(this, {
            $http: $http,
            $q: $q,
            $localStorage: $localStorage,
            $mdDialog: $mdDialog,
            $state: $state
        });
    }

    createUser(withDetails, setUser = true) {
        let deferred = this.$q.defer();

        this.$http({
            method: 'POST',
            url: AUTH_SIGN_UP,
            headers: "application/json; charset=utf-8",
            data: {user: withDetails}
        }).then(
            (response) => {
                let data = response.data;
                if (data.success) {
                    if (!this.isAdminUser() && setUser) {
                        this.setCurrentUser(data.user);
                    }
                    deferred.resolve({
                        id: data.user.id,
                        phone_number: data.user.phone_number
                    });
                }
                deferred.reject({message: data.error || 'Unable to create user.'});
            },
            (error) => {
                console.log(error);
                deferred.reject({message: data.error || 'Unable to create user.'});
            }
        );

        return deferred.promise;
    }

    login(tpin, phoneNumber) {
        let deferred = this.$q.defer();

        this.$http({
            method: 'POST',
            url: AUTH_SIGN_IN,
            headers: "application/json; charset=utf-8",
            data: {
                user: {
                    phone_number: phoneNumber,
                    password: tpin
                }
            }
        }).then(
            (response) => {
                this.setCurrentUser(response.data.user);
                deferred.resolve(this.currentUser());
            },
            (error) => {
                console.log(error);
                deferred.reject({message: 'Could not validate TPin'});
            }
        );

        return deferred.promise;
    }

    loginUsingTpinModal() {
        /**
         * If multiple login requests are requested,
         *  re use the first one for every subsequent request
         */
        if (this._authPromise) {
            return this._authPromise;
        }

        this._authPromise = this.$mdDialog.show({
                controller: require('common/auth/modals/auth.loginTpin.controller'),
                controllerAs: 'login',
                template: require('common/auth/modals/auth.loginTpin.html'),
                parent: angular.element(document.body),
                clickOutsideToClose: true
            })
            .then(
                () => this._authPromise = null,
                () => this._authPromise = null
            );

        return this._authPromise;
    }

    loginUsingNumberModal() {
        if (this._authPromise) {
            return this._authPromise;
        }

        this._authPromise = this.$mdDialog.show({
                controller: require('common/auth/modals/auth.loginNumber.controller'),
                controllerAs: 'login',
                template: require('common/auth/modals/auth.loginNumber.html'),
                parent: angular.element(document.body),
                clickOutsideToClose: true
            })
            .then(
                () => this._authPromise = null,
                () => this._authPromise = null
            );

        return this._authPromise;
    }

    isAuthenticated() {
        const currentUser = this.currentUser();
        return _.isObject(currentUser) && !_.isEmpty(currentUser) && !_.isUndefined(currentUser.authentication_token);
    }

    isAdminUser() {
        return _.contains(this.$state.current.name, 'admin');
    }

    logout() {
        delete this.$localStorage.user;
        /*FreshChat Integration*/
        localStorage.setItem('appUser', false);
        window.fcSettings = {
            token: "111225dc-f8ec-42fd-b63e-5c99cbb25f43",
            host: "https://wchat.freshchat.com"
        };
        /*FreshChat Integration*/
        return this.$state.go('base.basic', { orderId: 'new' });
    }

    setCurrentUser(user) {
        /*hack checks for name and authentication fields in api response*/
        if(!user.name && user.first_name) {
            user.name = user.first_name;
            delete user.first_name;
        }
        if(!user.authentication_token && user.user_token) {
            user.authentication_token = user.user_token;
            delete user.user_token;
        }
        this.$localStorage.user = user;
        /*FreshChat Integration*/
        localStorage.setItem('appUser', JSON.stringify(user));
        window.fcSettings = {
            token: "111225dc-f8ec-42fd-b63e-5c99cbb25f43",
            host: "https://wchat.freshchat.com",
            externalId: user.id,     // user’s id unique to your system
            firstName: user.name,              // user’s first name
            lastName: "",                // user’s last name
            email: user.email,    // user’s email address
            phone: user.number,            // phone number without country code
            phoneCountryCode: "+91"          // phone’s country code
        };
        /*FreshChat Integration*/
        /* Woopra Identify */
        woopra.identify({
            id: user.id,
            email: user.email,
            name: user.name,
            number: user.number
        });

        woopra.track();
        /* Woopra Identify */
    }

    currentUser() {
        return _.cloneDeep(this.$localStorage.user);
    }
}

export default Auth;


// WEBPACK FOOTER //
// ./client/app/common/auth/auth.js